const AddIcon = ({
  className = ""
}: {
  className?: string;
}) => {
  return <svg xmlns='http://www.w3.org/2000/svg' fill='none' width='24' height='24' viewBox='0 0 24 24' strokeWidth={2.5} stroke='currentColor' className={`${className} inline-block`} role='img' aria-labelledby='accordionOpenIconTitle' data-sentry-element="svg" data-sentry-component="AddIcon" data-sentry-source-file="AddIcon.tsx">
      <title id='accordionOpenIconTitle'>Accordion open icon</title>
      <path strokeLinecap='round' strokeLinejoin='round' d='M12 4.5v15m7.5-7.5h-15' data-sentry-element="path" data-sentry-source-file="AddIcon.tsx" />
    </svg>;
};
export default AddIcon;